import {getLocaleCodes} from './helpers'
import history from './history'
import routerEvents, { CHANGE_LOCALE_CODE_EVENT } from './events'

let currentLocaleCode = ''

export function detectLocaleChange() {
  const [localCode] = history.location.pathname.replace(/^\//, '').split('/')

  if (getLocaleCodes().includes(localCode)) {
    routerEvents.trigger(CHANGE_LOCALE_CODE_EVENT, localCode, currentLocaleCode)

    currentLocaleCode = localCode
  }

  routerEvents.onLocalCodeChange((newLocaleCode) => {
    currentLocaleCode = newLocaleCode
  })
}
